import styles from './HeaderItem.scss';

import cx from 'classnames';
import { ReferencedEntry } from 'contentful';
import React from 'react';

import { Subject } from 'src/api/contentful/contentTypes.cloverdotcom';
import { ContentLink } from 'src/components/ContentLink/ContentLink';
import { Blurb } from 'src/components/Contentful/Blurb';
import { Text } from 'src/components/Contentful/Text';
import { EnhancedMedia } from 'src/components/EnhancedMedia/EnhancedMedia';
import { getField, isEntry } from 'src/utils/EntryUtil';

export interface IHeaderItem extends React.AllHTMLAttributes<HTMLAnchorElement> {
  entry?: ReferencedEntry<Subject>;
  columnMode?: boolean;
}

export const HeaderItem: React.FC<IHeaderItem> = ({ entry, columnMode, className, ...props }) => !isEntry(entry) ? null : (
  <ContentLink
    alwaysRenderChildren
    hideTitle
    className={cx(className, styles.headerItem, {
      [styles.headerItemColMode]: columnMode,
    })}
    entry={getField(entry, 'link')}
    {...props}
  >
    <div className={styles.textWrapper}>
      <Text tagName="h3" className={styles.title} entry={entry} field="title" />
      <Blurb entry={entry} field="blurb" />
    </div>
    <EnhancedMedia className={styles.media} entry={entry} preferHeight />
  </ContentLink>
);
